/** An enrichment that claims nothing. The honest answer to a failed call. */
export const EMPTY_ENRICHMENT = {
    category: null,
    emoji: null,
    quantity: null,
    nutrition: null,
    confidence: 0,
};
/**
 * The most items one call may carry.
 *
 * A grocery run is the point of batching, and 30 is the daily scan allowance in
 * `functions/src/access.ts`, so it is already the app's idea of "a big shop".
 * Beyond this the output would risk the token ceiling, and a truncated JSON
 * array loses every item rather than the last one.
 */
export const MAX_BATCH = 30;
//# sourceMappingURL=types.js.map